import { useDashboardAdminState } from "lib/states/adminState";
import { useDashboardLoaderState } from "lib/states/dashboardLoaderState";
import { useDrawerState } from "lib/states/drawerState";
import { useCallback } from "react";
import { atom, useRecoilState } from "recoil";

const greetings = [
  "Hope you're doing well",
  "Wishing you a productive day",
  "Stay positive and keep going",
  "Keep up the great work",
  "Have a fantastic day ahead",
];

const adminLoaderState = atom<Boolean>({
  key: "admin-info-loader",
  default: true,
});

export default function useFunctions() {
  const [open, setOpen] = useDrawerState();
  const [loader, setLoader] = useRecoilState(adminLoaderState);
  const [loading] = useDashboardLoaderState();
  const [admin, setAdmin] = useDashboardAdminState();
  const getRandomGreeting = () =>
    greetings[Math.floor(Math.random() * greetings.length)];

  const handleDrawerToggle = () => {
    setOpen(!open);
  };
  const getUser = useCallback(async () => {
    setLoader(true);
    // Get email from localStorage
    const email = localStorage.getItem("admin_email") || "admin@soundlabs.com";
    const namePart = email.split("@")[0];
    const name = namePart.charAt(0).toUpperCase() + namePart.slice(1);
    setAdmin({ name, email, createdAt: "" });
    setLoader(false);
  }, [setAdmin, setLoader]);

  return {
    getRandomGreeting,
    loader,
    loading,
    admin,
    open,
    setOpen,
    handleDrawerToggle,
    getUser,
  };
}
